import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/guobiao-majiang', label: t('nav.categories') },
    { to: '/category/majiang-jiqiao', label: t('nav.articles') },
    { to: '/about', label: t('nav.about') },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-heading font-bold whitespace-nowrap"
            style={{ color: scrolled || !isHome ? 'oklch(var(--primary-600))' : 'white' }}
          >
            <i className="ri-stack-line text-2xl"></i>
            <span>{t('site.name')}</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:opacity-80 ${
                  scrolled || !isHome
                    ? 'text-foreground-700'
                    : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/xinshou-rumen"
              className="px-5 py-2 rounded-md bg-primary-500 text-white text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              {t('hero.cta')}
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md"
            style={{ color: scrolled || !isHome ? 'oklch(var(--foreground-700))' : 'white' }}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/xinshou-rumen"
              className="px-5 py-2 rounded-md bg-primary-500 text-white text-sm font-medium whitespace-nowrap text-center hover:bg-primary-600 transition-colors duration-200"
            >
              {t('hero.cta')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}